import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[uiInputFocus]',
})
export class UiInputFocusDirective {
  private elementRef = inject(ElementRef);

  readonly isFocused = input(false, { alias: 'uiInputFocus' });

  constructor() {
    effect(() =>
      this.isFocused()
        ? this.elementRef.nativeElement.focus()
        : this.elementRef.nativeElement.blur(),
    );
  }
}
